import script from "./UiGoal.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiGoal.vue?vue&type=script&setup=true&lang=ts"

const cssModules = {}
import style0 from "./UiGoal.vue?vue&type=style&index=0&id=0f635957&lang=scss&module=true"
cssModules["$style"] = style0
import "./UiGoal.vue?vue&type=style&index=1&id=0f635957&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__